import { Api } from "./Api";

export default {
    index() {
        return Api.get(`/v1/management/dbsubs`);
    },
    show(dbsub_id) {
        return Api.get(`/v1/management/dbsubs/${dbsub_id}`);
    },
    store(obj) {
        return Api.post(`/v1/management/dbsubs`, obj);
    },
    update(dbsub_id, obj) {
        return Api.put(`/v1/management/dbsubs/${dbsub_id}`, obj);
    },
    delete(dbsub_id) {
        return Api.delete(`/v1/management/dbsubs/${dbsub_id}`);
    },
}